function User({
    user_id = "",
    user_name = "",
    permission = 99,
    reset = false,
    token = "",
}) {
    this.userId = user_id;
    this.username = user_name;
    this.permission = permission;
    this.reset = reset;
    this.token = token;
}

export default User;